export const faqItems = [
  {
    question: '糖心视频需要下载APP吗？',
    answer: '不需要！糖心视频是纯网页端平台，打开浏览器即可观看，无需下载任何APP。我们采用先进的视频压缩和CDN加速技术，确保流畅的在线观看体验。',
  },
  {
    question: '糖心视频的影视资源是否需要付费？',
    answer: '糖心视频是一个免费的影视聚合平台，所有内容均可免费在线观看。我们通过聚合各大视频平台的公开资源，为用户提供一站式的观影服务。',
  },
  {
    question: '为什么有些视频无法播放？',
    answer: '由于我们聚合的是第三方平台的资源，部分视频可能因源站下架、版权调整等原因暂时无法播放。我们会持续监控资源状态并及时更新。如遇到无法播放的情况，建议尝试其他推荐资源。',
  },
  {
    question: '糖心视频支持哪些设备观看？',
    answer: '糖心视频全面支持PC端、平板和手机浏览器访问，自适应各种屏幕尺寸。无论您使用Windows、Mac、iOS还是Android设备，都能获得良好的观看体验。',
  },
  {
    question: '视频画质如何？有高清选项吗？',
    answer: '我们优先收录高清及以上画质的视频资源，大部分内容支持1080P高清播放。部分最新影视作品还支持4K超高清画质，让您享受极致的观影体验。',
  },
  {
    question: '糖心视频会更新最新的影视内容吗？',
    answer: '会的！我们的内容团队每天24小时不间断更新，确保第一时间收录最新上映的电影、热播电视剧和综艺节目。通常热门内容在上线后2-4小时内即可在糖心视频找到。',
  },
  {
    question: '如何搜索我想看的影片？',
    answer: '您可以使用页面顶部的搜索框输入影片名称、演员或导演名字进行搜索。也可以通过首页的分类导航浏览不同类型的内容，或查看"热门推荐"和"最新更新"板块发现精彩内容。',
  },
];

export const aboutInfo = {
  brandIntro: {
    title: '关于糖心视频',
    paragraphs: [
      '糖心视频创立于2024年，是一家专注于影视内容聚合与推荐的互联网平台。我们的使命是"让每个人都能轻松找到想看的影视内容"，通过技术手段打破平台壁垒，为用户提供一站式的观影体验。',
      '糖心视频的名字寓意"甜蜜的内心"，我们希望每一位用户在使用我们的平台时，都能感受到如糖果般甜蜜愉悦的观影体验。无论您喜欢热映大片、经典老片、热播剧集还是小众文艺片，糖心视频都能满足您的需求。',
      '经过两年的发展，糖心视频已聚合了超过12,000部影视资源，涵盖了电影、电视剧、综艺、动漫、纪录片等多种类型。日均活跃用户超过800万，已成为国内领先的影视聚合平台之一。',
    ],
  },
  reputation: {
    title: '用户口碑',
    testimonials: [
      {
        name: '王先生',
        avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20portrait%20photo%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20headshot%20style%2C%20warm%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish',
        role: '资深影迷',
        content: '用了糖心视频半年多了，真的非常方便！以前要在好几个APP之间切换找片，现在一个网站就搞定了。资源更新也很快，好评！',
      },
      {
        name: '李女士',
        avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20portrait%20photo%2C%20warm%20smile%2C%20clean%20white%20background%2C%20headshot%20style%2C%20soft%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish',
        role: '追剧达人',
        content: '作为一个追剧狂人，糖心视频简直是我的救星。更新速度超快，画质也好，而且完全免费。已经推荐给身边所有朋友了！',
      },
      {
        name: '张同学',
        avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20male%20student%20portrait%2C%20casual%20friendly%20look%2C%20clean%20white%20background%2C%20headshot%20style%2C%20natural%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish',
        role: '大学生',
        content: '宿舍晚上追剧全靠糖心视频！不卡顿，资源全，而且界面设计得也很清爽。希望平台越来越好，收录更多好片！',
      },
    ],
  },
  contact: {
    title: '联系我们',
    description: '如果您有任何问题、建议或合作意向，欢迎通过以下方式与我们联系。我们的团队会在1-2个工作日内回复您。',
    email: 'contact@tangxinsp.com',
    wechat: 'TangXinVideo',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
    phone: '400-888-0000',
  },
};